"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Disable = void 0;
const React = require("react");
const Loader_1 = require("../Loader");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "Disable");
/**
 * Component conditionally rendering a disabled styled overlay on its content
 * Includes options to render a spinner and a message
 */
const Disable = ({ children, disabled, message, showSpinner = false }) => {
    return (React.createElement("div", { className: css("", { "-active": disabled }) },
        React.createElement("div", { className: css("content") }, children),
        React.createElement("div", { className: css("overlay") },
            showSpinner && React.createElement(Loader_1.Loader, { size: "md" }),
            !!message && React.createElement("div", { className: css("message") }, message))));
};
exports.Disable = Disable;
//# sourceMappingURL=index.js.map